import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClientService } from 'src/app/services/http-client.service';

@Injectable()
export class HeaderService {

  private readonly urlAPI = environment.apiLogin;

  constructor(
    private _http: HttpClient,
    private http: HttpClientService
    ) { }

    urlApi = environment.api;
    token = sessionStorage.getItem('loginAuth');

  getUser(token: any): Promise<any> {
    const url: string = this.urlAPI + `/getUserInfoBrasilCidadao?token=${token}`;
    return this._http.get(url)
      .toPromise()
      .then(response => response);
  }

}